<template>
  <section id="checkout" class="checkout-section">
    <div class="container">
      <div class="section-title mb45 headline text-center">
        <span class="subtitle text-uppercase">YOUR SHOPPING CART</span>
        <h2><span>{{details.Name}}</span></h2>
        <div class="span-content" v-html="details.RegistrationDesc"></div>
      </div>
      <div class="checkout-content">
        <div class="row">
          <div class="col-md-9">
            <div class="box">
              <div class="search-row">
                <div class="title">报名<b>岗位</b></div>
                <div class="search-job">
                  <div class="search-label">搜索条件</div>
                  <el-input class="search-input" placeholder="岗位名称" v-model="searanJobName" clearable></el-input>
                </div>
              </div>
              <el-table :data="showCourseJobs" class="table-base">
                <el-table-column label="岗位" header-align='left' width="260" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="item">
                      <div>
                        <span style="color: #333333;font-weight: bold;">{{scope.row.Name}}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="报名费" header-align='left' show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="item">
                      <div>
                        <span>￥{{scope.row.Price}}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="报名人数" header-align='left' show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="item">
                      <div>
                        <span>{{!scope.row.Count?0:scope.row.Count}}人</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="小计" header-align='left' show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="item">
                      <div>
                        <span>￥{{!scope.row.Count?0:scope.row.Count * scope.row.Price }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="160" header-align="center" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.Count" type="primary" class="btn-job" @click="goCourseEnrollStudent(scope.row)">已报名 {{scope.row.Count}} 人</el-button>
                    <el-button v-else type="primary" class="btn-job" @click="goCourseEnrollAddStudent(scope.row)">选择学员</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form v-if="enableLearnIsPackageOrder == true" :model="model" status-icon :rules="rules" ref="ruleForm">
              <div class="box-kpxx">
                <div class="kpxx-title">套餐<b>订单</b></div>
                <div class="row">
                  <div class="col-md-6">
                    <el-form-item prop="IsPackageOrder">
                      <span style="font-size:16px">套餐订单：&nbsp;&nbsp;</span>
                      <el-radio-group v-model="model.IsPackageOrder">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
            <el-form v-if="projectName == 'SRJZY'" :model="model" status-icon :rules="rules" ref="ruleForm">
              <div class="box-kpxx" id="kpInfo">
                <div class="kpxx-title">开票<b>信息</b></div>
                <div class="row">
                  <div class="col-md-6">
                    <el-form-item prop="InvoiceTitle">
                      <el-autocomplete style="width:100%" :fetch-suggestions="getEnterpriseInvoiceTitle" placeholder="发票抬头" v-model.trim="model.InvoiceTitle"></el-autocomplete>
                    </el-form-item>
                  </div>
                  <div class="col-md-6">
                    <el-form-item prop="TaxpayerNumber">
                      <el-autocomplete style="width:100%" :fetch-suggestions="getEnterpriseTaxpayerNumber" placeholder="纳税人识别号" v-model.trim="model.TaxpayerNumber"></el-autocomplete>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
            <el-form v-if="details.IsEnableLearnReceive == 1" :model="model" status-icon :rules="rules" ref="ruleForm">
              <div class="box-kpxx">
                <div class="kpxx-title">领取<b>发票</b></div>
                <div class="row">
                  <div class="col-md-6">
                    <el-form-item prop="ReceiveMethodId">
                      <span style="font-size:16px">领取方式：&nbsp;&nbsp;</span>
                      <el-radio-group v-if="enableLearnDZFP == true" id="ReceiveMethodRadio" v-model="model.ReceiveMethodId">
                        <el-radio :label="3">电子发票</el-radio>
                      </el-radio-group>
                      <el-radio-group v-else id="ReceiveMethodRadio" v-model="model.ReceiveMethodId">
                        <el-radio :label="1">自取</el-radio>
                        <el-radio :label="2">邮寄</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>
                <div class="row" v-if="model.ReceiveMethodId === 2">
                  <div class="col-md-6">
                    <el-form-item prop="ReceivePerson">
                      <el-input placeholder="收件人" v-model.trim="model.ReceivePerson"></el-input>
                    </el-form-item>
                  </div>
                  <div class="col-md-6">
                    <el-form-item prop="ReceiveMobile">
                      <el-input placeholder="手机号" v-model.trim="model.ReceiveMobile"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="row" v-if="model.ReceiveMethodId === 2">
                  <div class="col-md-12">
                    <el-form-item prop="ReceiveAddress">
                      <el-input placeholder="邮寄地址" v-model.trim="model.ReceiveAddress"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="row" v-if="model.ReceiveMethodId === 3">
                  <div class="col-md-6">
                    <el-form-item prop="ReceiveEmail">
                      <el-autocomplete style="width:100%" :fetch-suggestions="getEnterpriseEmail" placeholder="发票接收电子邮箱（必填）" v-model.trim="model.ReceiveEmail"></el-autocomplete>
                    </el-form-item>
                  </div>
                  <div class="col-md-6">
                    <el-form-item>
                      <el-autocomplete style="width:100%" :fetch-suggestions="getEnterpriseMobile" placeholder="发票接收手机号（选填）" v-model.trim="model.ReceiveMobile"></el-autocomplete>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
            <el-form v-if="registLearnSettings.LearnProjectNameVisible" :model="model" status-icon :rules="rules" ref="projectForm">
              <div class="box-kpxx" id="projectInfo">
                <div class="kpxx-title">项目<b>信息</b></div>
                <div class="row">
                  <div class="col-md-12">
                    <el-form-item prop="ProjectName">
                      <el-input placeholder="项目名称" v-model.trim="model.ProjectName" maxlength="50"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="row" v-if="registLearnSettings.LearnProjectAddressVisible">
                  <div class="col-md-12">
                    <el-form-item prop="ProjectAddress">
                      <el-input placeholder="建设地点" v-model.trim="model.ProjectAddress"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="row" v-if="registLearnSettings.LearnProjectStarTimeVisible || registLearnSettings.LearnProjectTimeLimitVisible">
                  <div class="col-md-6" v-if="registLearnSettings.LearnProjectStarTimeVisible">
                    <el-form-item prop="ProjectStarTime">
                      <el-date-picker style="width:100%" placeholder="开工时间" v-model="model.ProjectStarTime" type="date" format="yyyy/MM/dd" value-format="yyyy/MM/dd">
                      </el-date-picker>
                    </el-form-item>
                  </div>
                  <div class="col-md-6" v-if="registLearnSettings.LearnProjectTimeLimitVisible">
                    <el-form-item prop="ProjectTimeLimit">
                      <el-input placeholder="工期" v-model.trim="model.ProjectTimeLimit"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
            <div class="box" style="margin-top:40px;">
              <div class="title">填写<b>备注</b></div>
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2}" v-model="model.Remark"></el-input>
            </div>
            <div id="pics" class="box" style="margin-top:40px;">
              <div class="title">上传<b>附件</b></div>
              <div class="pics">
                <div v-if="registLearnSettings.LearnWtsVisible">
                  <div :class="['item-sc-btn', model.PicWts ? '' : 'isActive']" v-show="model.PicWts == null" @click="picUpdate('file_wts')">
                    <div>+</div>
                    <div style="font-size:14px;">委托书</div>
                    <input type="file" id="file_wts" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handleAvatarSuccess($event, 4)">
                  </div>
                  <span v-if="!model.PicWts" class="span_error">请上传委托书</span>
                  <k-btn-img v-show="model.PicWts != null" :slides="model" :src="model.PicWts">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='model.PicWts' id="pic_wts" :src="model.PicWts + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('pic_wts')">查看大图</div>
                      <div @click="picUpdate('file_wts')">重新上传</div>
                    </template>
                  </k-btn-img>
                </div>

                <div v-if="registLearnSettings.LearnCnsVisible">
                  <div :class="['item-sc-btn', model.PicCns ? '' : 'isActive']" v-show="model.PicCns == null" @click="picUpdate('file_cns')">
                    <div>+</div>
                    <div style="font-size:14px;">承诺书</div>
                    <input type="file" id="file_cns" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handleAvatarSuccess($event, 5)">
                  </div>
                  <span v-if="!model.PicCns" class="span_error">请上传承诺书</span>
                  <k-btn-img v-show="model.PicCns != null" :slides="model" :src="model.PicCns">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='model.PicCns' id="pic_cns" :src="model.PicCns + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('pic_cns')">查看大图</div>
                      <div @click="picUpdate('file_cns')">重新上传</div>
                    </template>
                  </k-btn-img>
                </div>

                <div v-if="registLearnSettings.LearnSghtVisible">
                  <div :class="['item-sc-btn', model.PicSght ? '' : 'isActive']" v-show="model.PicSght == null" @click="picUpdate('file_sght')">
                    <div>+</div>
                    <div style="font-size:14px;">中标通知书<br />或施工合同</div>
                    <input type="file" id="file_sght" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handleAvatarSuccess($event, 6)">
                  </div>
                  <span v-if="!model.PicSght" class="span_error">请上中标通知书或施工<br />合同</span>
                  <k-btn-img v-show="model.PicSght != null" :slides="model" :src="model.PicSght">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='model.PicSght' id="pic_sght" :src="model.PicSght + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('pic_sght')">查看大图</div>
                      <div @click="picUpdate('file_sght')">重新上传</div>
                    </template>
                  </k-btn-img>
                </div>

                <div v-if="registLearnSettings.LearnDjbVisible">
                  <div :class="['item-sc-btn', model.PicDjb ? '' : 'isActive']" v-show="model.PicDjb == null" @click="picUpdate('file_djb')">
                    <div>+</div>
                    <div style="font-size:14px;">登记表</div>
                    <input type="file" id="file_djb" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handleAvatarSuccess($event, 7)">
                  </div>
                  <span v-if="!model.PicDjb" class="span_error">请上传登记表</span>
                  <k-btn-img v-show="model.PicDjb != null" :slides="model" :src="model.PicDjb">
                    <template slot="img" slot-scope="scope1">
                      <img :data-original='model.PicDjb' id="pic_djb" :src="model.PicDjb + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                    </template>
                    <template slot="btn" slot-scope="scope2">
                      <div @click="onClickImg('pic_djb')">查看大图</div>
                      <div @click="picUpdate('file_djb')">重新上传</div>
                    </template>
                  </k-btn-img>
                </div>

                <div class="item-sc-btn" v-show="model.Pic1 == null" @click="picUpdate('file_pic1')">
                  <div>+</div>
                  <div style="font-size:14px;">上传附件</div>
                  <input type="file" id="file_pic1" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handleAvatarSuccess($event,1)">
                </div>
                <k-btn-img v-show="model.Pic1 != null" :slides="model" :src="model.Pic1">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='model.Pic1' id="img_pic1" :src="model.Pic1 + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('img_pic1')">查看大图</div>
                    <div @click="picUpdate('file_pic1')">重新上传</div>
                  </template>
                </k-btn-img>

                <div class="item-sc-btn" v-show="model.Pic2 == null" @click="picUpdate('file_pic2')">
                  <div>+</div>
                  <div style="font-size:14px;">上传附件</div>
                  <input type="file" id="file_pic2" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handleAvatarSuccess($event,2)">
                </div>
                <k-btn-img v-show="model.Pic2 != null" :slides="model" :src="model.Pic2">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='model.Pic2' id="img_pic2" :src="model.Pic2 + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('img_pic2')">查看大图</div>
                    <div @click="picUpdate('file_pic2')">重新上传</div>
                  </template>
                </k-btn-img>

                <div class="item-sc-btn" v-show="model.Pic3 == null" @click="picUpdate('file_pic3')">
                  <div>+</div>
                  <div style="font-size:14px;">上传附件</div>
                  <input type="file" id="file_pic3" class="el-upload__input" multiple accept="image/jpeg,image/jpg,image/png" @change="handleAvatarSuccess($event,3)">
                </div>
                <k-btn-img v-show="model.Pic3 != null" :slides="model" :src="model.Pic3">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='model.Pic3' id="img_pic3" :src="model.Pic3 + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('img_pic3')">查看大图</div>
                    <div @click="picUpdate('file_pic3')">重新上传</div>
                  </template>
                </k-btn-img>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="side-bar-widget first-widget">
              <h2 class="widget-title text-capitalize">报名 <span>结算</span></h2>
              <div class="sub-total-item">
                <div class="purchase-list mt15 ul-li-block">
                  <ul>
                    <li style="overflow: hidden;" v-for="item in courseJobs" :key="item.Id" v-if="item.Count">{{item.Name}} <span>￥{{item.Count*item.Price}}</span></li>
                  </ul>
                  <div class="in-total">总计 <span>￥{{totalPrice}}</span></div>
                </div>
              </div>
              <div style="display: flex; margin-top: 15px;">
                <el-button style="width: 100px; padding: 0 !important; text-align: center;" class="k-btn-default lg" @click="onCancel" :disabled="submitDisabled" :loading="submitDisabled">取消报名</el-button>
                <el-button style="width:160px;" class="k-btn-default lg" @click="onSave" :disabled="submitDisabled" :loading="submitDisabled">保存报名</el-button>
              </div>
              <el-button v-if="rsCount>0" class="k-btn-primary lg" style="width:100%;margin-top:15px" @click="onSubmit" :disabled="submitDisabled" :loading="submitDisabled">下一步并确认报名信息</el-button>
              <el-button v-if="rsCount==0" class="k-btn-default lg" style="width:100%;margin-top:15px;cursor: no-drop;">下一步并确认报名信息</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-if="projectName== 'NCJZJY'" id="dialog-zytz" title="" :visible.sync="zytzDialogVisible" :before-close="handleZytzDialogCancel" :show-close='false' :close-on-click-modal='false'>
      <div class="box-dialog">
        <div class="box-title">重要通知</div>
        <div class="box-row" style="margin-top:32px">
          <div style="width: 498px;padding-right: 40px;font-size: 16px;">
            <p>因事业单位改革，原建校划转为“南昌高级技工学校”，建校账号从2023年2月1日起停止使用，并从2月1日起启用新账户，请各单位转账后截图发群里让老师开通学习。新账户如下：</p>
            <p>收款户名：<span>南昌技师学院</span> <a href="javascript:void(0);" class="text-link copy-text" data-clipboard-text="因事业单位改革，原建校划转为“南昌高级技工学校”，建校账号从2023年2月1日起停止使用，并从2月1日起启用新账户，请各单位转账后截图发群里让老师开通学习。新账户如下：\n收款户名：南昌技师学院\n收款帐号：1502207029081005612-000000002\n收款银行：中国工商银行股份有限公司南昌胜利支行\n注：单位对公转账无需备注，个人转账请务必备注“单位全称”，并完善网站上单位信息，转账后第二个月电子发票将发送到单位经办人邮箱。">点击此处复制</a></p>
            <p>收款帐号：<span>1502207029081005612-000000002</span></p>
            <p>收款银行：<span>中国工商银行股份有限公司南昌胜利支行</span></p>
            <p>注：单位对公转账无需备注，个人转账请务必备注“单位全称”，并完善网站上单位信息，转账后第二个月电子发票将发送到单位经办人邮箱。</p>
          </div>
          <div>
            <img src="https://ncjzjy-1253588055.cos.ap-shanghai.myqcloud.com/assets/%E6%8A%A5%E5%90%8D%E9%87%8D%E8%A6%81%E9%80%9A%E7%9F%A5.png">
          </div>
        </div>
        <div class="box-row" style="justify-content: flex-end;margin-top:10px">
          <el-button class="el-button el-button--default el-button--small el-button--primary" @click="handleZytzDialogCancel">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-if="projectName== 'SRJZY'" id="dialog-zytz" title="" :visible.sync="zytzDialogVisible" :before-close="handleZytzDialogCancel" :show-close='false' :close-on-click-modal='false'>
      <div class="box-dialog">
        <div class="box-title">重要通知</div>
        <div class="box-row" style="margin-top:32px">
          <div style="width: 498px;padding-right: 40px;font-size: 16px;">
            <p>即日起缴费账号“上饶市国控教育科技有限公司”停止使用。所有课程的缴费账号统一为“上饶市国控职业培训学校有限公司”，详细信息如下：</p>
            <p>收款户名：<span>上饶市国控职业培训学校有限公司</span> <a href="javascript:void(0);" class="text-link copy-text" data-clipboard-text="收款户名：上饶市国控职业培训学校有限公司；收款帐号：159389010000033356；收款银行：上饶农村商业银行股份有限公司三清支行；注：转账时请备注企业简称及报名编号，缴费后请上传缴费凭证至平台。">点击此处复制</a></p>
            <p>收款帐号：<span>159389010000033356</span></p>
            <p>收款银行：<span>上饶农村商业银行股份有限公司三清支行</span></p>
            <p>注：转账时请备注企业简称及报名编号，缴费后请上传缴费凭证至平台。</p>
            <div style="padding-left: 32px;color: #ff6715;"><el-checkbox v-model="zytzDialogChecked"></el-checkbox>&nbsp;&nbsp;我已知晓</div>
          </div>
          <div style="width:238px;display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <img src="https://srsjzy-1253588055.cos.ap-shanghai.myqcloud.com/assets/fk_qrcode.jpg" style="width: 180px;">
            <div style="background-color: rgb(240,240,240); padding: 10px; color: #333; margin-top: 10px;">使用支付宝、云闪付扫一扫付款，付款说明输入企业简称和报名编号。</div>
          </div>
        </div>
        <div class="box-row" style="justify-content: end; margin-top: 16px;">
          <el-button class="el-button el-button--default el-button--small el-button--primary" @click="handleZytzDialogCancel">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-if="projectName== 'SRJZY'" id="dialog-yqts" title="" :visible.sync="yqtsDialogVisible" :before-close="handleYqtsDialogCancel" :show-close='false' :close-on-click-modal='false'>
      <div class="box-dialog">
        <div class="box-title">友情提示</div>
        <div class="box-row" style="margin-top:32px;font-size:24px">
          <p>因属地管理原则， <span style="color:#ff6715">鄱阳县</span> 和 <span style="color:#ff6715">婺源县</span> 的企业无法参加上饶三类人员初始考试，八大员和特种作业人员不受属地管理影响，可正常报名培训，请以上两个县的企业慎重报名，切勿报错！！</p>
        </div>
        <div class="box-row" style="justify-content: end; margin-top: 16px;">
          <el-button class="el-button el-button--default el-button--small el-button--primary" @click="handleYqtsDialogCancel">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import Cookies from 'js-cookie'
import ClipboardJS from 'clipboard';
import { ProjectSettings } from '@/views/base/base.js'
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
let viewer = null;

export default {
  name: 'courseEnroll',
  data() {
    let checkMobile = (rule, value, callback) => {
      if (this.model.ReceiveMethodId === 2 && Utils.checkPhone(value) === false) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    let checkPerson = (rule, value, callback) => {
      if (this.model.ReceiveMethodId === 2 && !value) {
        callback(new Error('请填写收件人'));
      } else {
        callback();
      }
    };
    let checkAddress = (rule, value, callback) => {
      if (this.model.ReceiveMethodId === 2 && !value) {
        callback(new Error('请填写邮寄地址'));
      } else {
        callback();
      }
    };
    let checkEmail = (rule, value, callback) => {
      console.log('checkEmail value', this.model.ReceiveEmail);
      if (this.model.ReceiveMethodId === 3) {
        if (value === null) {
          callback(new Error('请输入用于接收电子发票的电子邮箱'));
        } else if (Utils.checkEmail(value) === false) {
          callback(new Error('邮箱格式错误，只能由英文和数字组成，格式：xxx@xxx.xxx'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      queryModel: {
        courseId: null
      },
      model: {
        CourseId: null,
        LearnId: null,
        IsPackageOrder: null,
        ReceiveMethodId: 2,
        ReceivePerson: '',
        ReceiveMobile: '',
        ReceiveAddress: '',
        ReceiveEmail: '',
        JobEmployees: [],
        Remark: '',
        Pic1: null,
        Pic2: null,
        Pic3: null,
        PicWts: null,
        PicCns: null,
        PicDjb: null,
        ProjectName: null,
        ProjectAddress: null,
        ProjectStarTime: null,
        ProjectTimeLimit: null,
        PicSght: null,
        InvoiceTitle: null,
        TaxpayerNumber: null
      },
      rules: {
        InvoiceTitle: [{ required: true, message: '请填写发票抬头', trigger: ['blur', 'change'] }],
        TaxpayerNumber: [{ required: true, message: '请填写纳税人识别号', trigger: ['blur', 'change'] }],
        ReceiveMethodId: [{ required: true, message: '请选择领取方式', trigger: ['blur', 'change'] }],
        ReceivePerson: [{ validator: checkPerson, trigger: ['blur', 'change'] }],
        ReceiveMobile: [{ validator: checkMobile, trigger: ['blur', 'change'] }],
        ReceiveAddress: [{ validator: checkAddress, trigger: ['blur', 'change'] }],
        ReceiveEmail: [{ validator: checkEmail, trigger: ['blur', 'change'] }],
        ProjectName: [{ required: true, message: '请填写项目名称', trigger: ['blur', 'change'] }],
        ProjectAddress: [{ required: true, message: '请填写建设地址', trigger: ['blur', 'change'] }],
        ProjectStarTime: [{ required: true, message: '请填写开工时间', trigger: ['blur', 'change'] }],
        ProjectTimeLimit: [{ required: true, message: '请填写工期', trigger: ['blur', 'change'] }]
      },
      enterpriseInfo: null,
      searanJobName: '',
      courseJobs: [],
      showCourseJobs: [],
      rsCount: 0,
      submitDisabled: false,
      registLearnSettings: {},
      projectName: ProjectSettings.Name,
      enableLearnDZFP: ProjectSettings.EnableLearnDZFP,
      enableLearnIsPackageOrder: ProjectSettings.EnableLearnIsPackageOrder,
      zytzDialogVisible: false,
      zytzDialogChecked: false,
      yqtsDialogVisible: false
    }
  },
  computed: {
    totalPrice: function () {
      let total = 0;
      _.forEach(this.courseJobs, item => {
        if (item.Count) {
          total += item.Count * item.Price;
        }
      });
      return total;
    },
    details: function () {
      return this.$store.getters.getCourseDetails;
    }
  },
  watch: {
    searanJobName: {
      handler(val, oldVal) {
        if (!val) {
          this.showCourseJobs = this.courseJobs;
        } else {
          let list = [];
          _.forEach(this.courseJobs, job => {
            if (job.Name.indexOf(val) !== -1) {
              list.push(job);
            }
          });
          this.showCourseJobs = list;
        }
      },
      deep: true
    }
  },
  mounted() {
    let that = this;
    viewer = null;

    // 第一次进入，判断是否弹出重要通知
    setTimeout(() => {
      if (Cookies.get('isZhongYaoTongZhi') === 'false') {
        this.zytzDialogVisible = true;
        this.zytzDialogChecked = false;
        Cookies.set('isZhongYaoTongZhi', 'true');
      }
    }, 500);

    let clipboard = new ClipboardJS('.copy-text');
    clipboard.on('success', function (e) {
      that.$message({
        type: 'success',
        message: '复制成功'
      });
      e.clearSelection();
    });

    // 是否开启套餐订单
    if (this.enableLearnIsPackageOrder === true) {
      this.model.IsPackageOrder = 0;
    }

    // 判断是否已有订单
    this.model.CourseId = Number(this.$route.query.CourseId);
    if (this.$route.query.LearnId) {
      this.model.LearnId = this.$route.query.LearnId;
    }

    // 处理订单配置
    let registLearnSettings = _.filter(ProjectSettings.RegistLearnSettings, (item) => {
      if (Number(item.CourseId) === Number(that.$route.query.CourseId)) {
        return true;
      }
    });

    if (registLearnSettings.length > 0) {
      this.registLearnSettings = registLearnSettings[0];
    }

    // 处理领取发票
    if (this.enableLearnDZFP === true) {
      this.model.ReceiveMethodId = 3;
    }

    this.$store.dispatch('getCourseDetails', { Id: this.model.CourseId });
    this.$store.dispatch('getMyEnterprise').then(res => {
      if (res.MsgCode === 0) {
        // 电子发票
        this.enterpriseInfo = res.Data;
        if (this.enableLearnDZFP !== true) {
          this.enterpriseInfo = res.Data;
          this.model.ReceivePerson = res.Data.ReceivePerson;
          this.model.ReceiveMobile = res.Data.ReceiveMobile;
          this.model.ReceiveAddress = res.Data.ReceiveAddress;
        }
      }
    });

    // 获得课程岗位信息，并根据原订单处理数据
    this.$store.dispatch('getCourseOpenJobs', { courseId: this.model.CourseId }).then(res => {
      let list = res.Data;
      let jobEmployees = this.$store.getters.getEnrollStudent;

      new Promise(function (resolve, reject) {
        if (jobEmployees.length === 0 && that.$route.query.LearnId) {
          that.$store.dispatch('getLearnLearnDetails', { Id: that.$route.query.LearnId }).then((res1) => {
            let learnDetails = res1.Data;
            let newJobEmployees = [];

            if (learnDetails.CourseId === that.model.CourseId) {
              // 转换订单数据
              that.model.IsPackageOrder = learnDetails.IsPackageOrder;
              that.model.ReceiveMethodId = learnDetails.ReceiveMethodId;
              that.model.ReceivePerson = learnDetails.ReceivePerson;
              that.model.ReceiveMobile = learnDetails.ReceiveMobile;
              that.model.ReceiveAddress = learnDetails.ReceiveAddress;
              that.model.ReceiveEmail = learnDetails.ReceiveEmail;
              that.model.Remark = learnDetails.Remark;
              that.model.Pic1 = learnDetails.Pic1;
              that.model.Pic2 = learnDetails.Pic2;
              that.model.Pic3 = learnDetails.Pic3;
              that.model.PicWts = learnDetails.PicWts;
              that.model.PicCns = learnDetails.PicCns;
              that.model.PicDjb = learnDetails.PicDjb;
              that.model.ProjectName = learnDetails.ProjectName;
              that.model.ProjectAddress = learnDetails.ProjectAddress;
              that.model.ProjectStarTime = learnDetails.ProjectStarTime;
              that.model.ProjectTimeLimit = learnDetails.ProjectTimeLimit;
              that.model.PicSght = learnDetails.PicSght;
              that.model.InvoiceTitle = learnDetails.InvoiceTitle;
              that.model.TaxpayerNumber = learnDetails.TaxpayerNumber;

              _.forEach(learnDetails.LearnJobAndEmployees, learnJob => {
                let tempJob = {
                  JobId: learnJob.JobId,
                  Employees: []
                };
                _.forEach(learnJob.LearnEmployees, element => {
                  tempJob.Employees.push({
                    EmployeeId: element.EmployeeId,
                    Pic: element.Pic,
                    Name: element.EmployeeName,
                    Sex: element.Sex,
                    IdNumber: element.IdNumber,
                    EmployeeDegree: element.EmployeeDegree,
                    EmployeeDegreeId: element.EmployeeDegreeId,
                    EmployeeTitle: element.EmployeeTitle,
                    Major: element.Major,
                    PicCns: element.PicCns,
                    PicXlzs: element.PicXlzs,
                    PicZcjzszs: element.PicZcjzszs,
                    PicTjb: element.PicTjb,
                    PicGzzm: element.PicGzzm,
                    PicBmb: element.PicBmb,
                    PicZyzs: element.PicZyzs,
                    PicSmpz: element.PicSmpz,
                    PicSfzzm: element.PicSfzzm,
                    PicSfzfm: element.PicSfzfm,
                    PicZp: element.PicZp,
                    PicHgz: element.PicHgz,
                    PicAkz: element.PicAkz,
                    PicCzz: element.PicCzz,
                    PicSqb: element.PicSqb,
                    PicSbzm: element.PicSbzm,
                    CertificateCode: element.CertificateCode,
                    CertificateDate: element.CertificateDate,
                    WorkYear: element.WorkYear,
                    NativePlace: element.NativePlace,
                    IsUploadPicXlzs: false,
                    IsUploadPicZcjzszs: false,
                    IsUploadPicSfzzm: false,
                    IsUploadPicSfzfm: false
                  });
                });
                newJobEmployees.push(tempJob);
                that.$store.dispatch('addEnrollStudent', tempJob);
              });

              resolve(newJobEmployees);
            }
          });
        } else {
          resolve(jobEmployees);
        }
      }).then(data => {
        jobEmployees = data;
        if (jobEmployees.length > 0) {
          _.forEach(list, item => {
            _.forEach(jobEmployees, emp => {
              if (item.Id === emp.JobId) {
                item.Count = emp.Employees.length;
                that.rsCount += emp.Employees.length;
              }
            });
          });
        }

        that.showCourseJobs = list;
        that.courseJobs = list;
      }).catch(res => {

      })
    });

    let model = this.$store.getters.getEnroll;
    if (model.CourseId && model.CourseId === that.model.CourseId) {
      that.model.IsPackageOrder = model.IsPackageOrder;
      that.model.ReceiveMethodId = model.ReceiveMethodId;
      that.model.ReceivePerson = model.ReceivePerson;
      that.model.ReceiveMobile = model.ReceiveMobile;
      that.model.ReceiveAddress = model.ReceiveAddress;
      that.model.ReceiveEmail = model.ReceiveEmail;
      that.model.Remark = model.Remark;
      that.model.Pic1 = model.Pic1;
      that.model.Pic2 = model.Pic2;
      that.model.Pic3 = model.Pic3;
      that.model.PicWts = model.PicWts;
      that.model.PicCns = model.PicCns;
      that.model.PicDjb = model.PicDjb;
      that.model.ProjectName = model.ProjectName;
      that.model.ProjectAddress = model.ProjectAddress;
      that.model.ProjectStarTime = model.ProjectStarTime;
      that.model.ProjectTimeLimit = model.ProjectTimeLimit;
      that.model.PicSght = model.PicSght;
      that.model.InvoiceTitle = model.InvoiceTitle;
      that.model.TaxpayerNumber = model.TaxpayerNumber;
    }
  },
  methods: {
    // 选着人
    goCourseEnrollStudent(row) {
      this.$store.dispatch('addEnroll', this.model);
      this.$router.push({ name: 'courseEnrollStudent', query: { jobId: row.Id, courseId: row.CourseId, learnId: this.$route.query.LearnId } });
    },
    goCourseEnrollAddStudent(row) {
      this.$router.push({
        name: 'courseEnrollAddStudent',
        query: {
          courseId: row.CourseId,
          jobId: row.Id,
          learnId: this.$route.query.LearnId
        },
        params: {
          employees: []
        }
      });
    },
    onSubmit() {
      let isValid = true;

      if (this.projectName === 'SRJZY' && (!this.model.InvoiceTitle || !this.model.TaxpayerNumber)) {
        this.$refs.ruleForm.validate((valid) => {
          isValid = valid;
          if (!valid) {
            this.$message.error('请填写开票信息');
            $('html,body').animate({ scrollTop: $('#kpInfo').offset().top }, 1000);
          }
        });
        return;
      }

      if (this.details.IsEnableLearnReceive === 1) {
        this.$refs.ruleForm.validate((valid) => {
          isValid = valid;
          if (!valid) {
            this.$message.error('请填写领取发票信息');
            $('html,body').animate({ scrollTop: $('#ReceiveMethodRadio').offset().top }, 1000);
          }
        });
      }

      if (!isValid) {
        return;
      }

      if (this.registLearnSettings.LearnProjectNameVisible) {
        this.$refs.projectForm.validate((valid) => {
          isValid = valid;
          if (!valid) {
            this.$message.error('请填写项目信息');
            $('html,body').animate({ scrollTop: $('#projectInfo').offset().top }, 1000);
          }
        });
      }

      if (!isValid) {
        return;
      }

      if ((this.registLearnSettings.LearnWtsVisible && !this.model.PicWts) || (this.registLearnSettings.LearnCnsVisible && !this.model.PicCns) || (this.registLearnSettings.LearnSghtVisible && !this.model.PicSght) || (this.registLearnSettings.LearnDjbVisible && !this.model.PicDjb)) {
        $('html,body').animate({ scrollTop: $('#pics').offset().top }, 1000);
        this.$message.error('请上传相关资料');
        return;
      }

      this.$store.dispatch('addEnroll', this.model);
      this.$router.push({ name: 'courseEnrollSubmit', query: { courseId: this.model.CourseId, learnId: this.$route.query.LearnId } });
    },
    onSave() {
      this.model.JobEmployees = _.cloneDeep(this.$store.getters.getEnrollStudent);
      let jobEmployees = [];

      // 去掉重复职业报名信息 （无效）
      this.model.JobEmployees = _.uniqBy(this.model.JobEmployees, 'JobId');

      // 去掉重复学员
      _.forEach(this.model.JobEmployees, item => {
        // 有时候会是字符串
        item.JobId = Number(item.JobId);

        let employees = _.find(jobEmployees, { 'JobId': item.JobId });
        if (!employees) {
          jobEmployees.push(item);
          employees = item.Employees;
        } else {
          employees = _.concat(employees, item.Employees);
        }

        employees = _.uniqBy(employees, 'EmployeeId');
      });

      // 去掉没有学员报名的职业
      jobEmployees = _.filter(jobEmployees, item => {
        return item.Employees.length > 0;
      });

      this.model.JobEmployees = jobEmployees;

      if (jobEmployees.length === 0) {
        this.$message.error('请选择学员');
        return;
      }

      this.submitDisabled = true;
      this.$store.dispatch('postLearnSave', this.model).then((response) => {
        if (response.MsgCode === 0) {
          this.$message({
            message: response.Message,
            type: 'success',
            duration: this.$setting.MESSAGE_DURATION
          });
          this.$router.push({ name: 'qyglwdbm' })
        } else {
          this.$alert(response.Message, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
        this.submitDisabled = false
      });
    },
    onCancel() {
      let that = this;

      this.$confirm('确定要取消报名吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((response) => {
        if (that.$route.query.LearnId) {
          that.submitDisabled = true;
          that.$store.dispatch('postLearnCancel', { learnId: that.$route.query.LearnId }).then((response) => {
            if (response.MsgCode === 0) {
              that.$message({
                message: response.Message,
                type: 'success',
                duration: that.$setting.MESSAGE_DURATION
              });
              that.$store.state.localModule.enrollstudent = [];
              that.$router.push({ name: 'qyglwdbm' })
            } else {
              that.$alert(response.Message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
            that.submitDisabled = false
          });
        } else {
          that.$store.state.localModule.enrollstudent = [];
          that.$router.push({ name: 'qyglwdbm' });
        }
      }).catch(() => {
      });
    },
    getEnterpriseEmail(queryString, cb) {
      let list = [{ 'value': this.enterpriseInfo.Email }];
      cb(list);
    },
    getEnterpriseMobile(queryString, cb) {
      let list = [{ 'value': this.enterpriseInfo.Mobile }];
      cb(list);
    },
    getEnterpriseInvoiceTitle(queryString, cb) {
      let invoiceTitle = this.enterpriseInfo.InvoiceTitle;
      if (!invoiceTitle) {
        invoiceTitle = this.enterpriseInfo.Name;
      }
      let list = [{ 'value': invoiceTitle }];
      cb(list);
    },
    getEnterpriseTaxpayerNumber(queryString, cb) {
      let taxpayerNumber = this.enterpriseInfo.TaxpayerNumber;
      if (!taxpayerNumber) {
        taxpayerNumber = this.enterpriseInfo.Uscc;
      }
      let list = [{ 'value': taxpayerNumber }];
      cb(list);
    },
    picUpdate(id) {
      $('#' + id).click();
    },
    // 上传图片
    handleAvatarSuccess(ev, type) {
      let that = this;
      const rawFile = ev.target.files[0];
      if (!rawFile) return;

      this.beforeAvatarUpload(rawFile);
      try {
        let image = new Image();
        image.src = window.URL.createObjectURL(rawFile);
        image.onload = function () {
          let obj = { Prefix: '', File: rawFile };
          that.$store.dispatch('postUploadPic', obj).then((res) => {
            switch (type) {
              case 1:
                that.model.Pic1 = res.Data;
                break;
              case 2:
                that.model.Pic2 = res.Data;
                break;
              case 3:
                that.model.Pic3 = res.Data;
                break;
              case 4:
                that.model.PicWts = res.Data;
                break;
              case 5:
                that.model.PicCns = res.Data;
                break;
              case 6:
                that.model.PicSght = res.Data;
                break;
              case 7:
                that.model.PicDjb = res.Data;
                break;
            }
          });
        };
      } catch (err) {
        console.error(err);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$alert('上传的资料限制为图片格式!', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
      if (!isLt2M) {
        this.$alert('上传的资料大小不能超过 2MB!', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
      return isJPG && isLt2M;
    },
    onClickImg(id) {
      if (viewer == null) {
        // 初始化 viewer.js
        viewer = new Viewer(document.getElementById('pics'), {
          url: 'data-original',
          filter: function (image) {
            if ($(image).prop('src') !== '' && $(image).hasClass('item-sc-img')) {
              return true;
            }
          }
        });
      }
      viewer.update();
      $('#' + id).click();
    },
    handleZytzDialogCancel() {
      console.log('this.zytzDialogChecked', this.zytzDialogChecked);
      if (this.projectName === 'SRJZY') {
        if (this.zytzDialogChecked === false) {
          this.$alert('仔细阅读重要通知，然后勾选我已知晓', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        } else {
          this.zytzDialogVisible = false;
          if (this.model.CourseId === 1) {
            if (this.enterpriseInfo.Address && (this.enterpriseInfo.Address.lastIndexOf('鄱阳') !== -1 || this.enterpriseInfo.Address.lastIndexOf('婺源') !== -1)) {
              this.yqtsDialogVisible = true;
            }
            //     this.$alert('<div font-size="16px">因属地管理原则，<span style="color:red">鄱阳县</span>和婺源县的企业无法参加上饶三类人员初始考试，八大员和特种作业人员不受属地管理影响，可正常报名培训，请以上两个县的企业慎重报名，切勿报错！！</div>', '友情提示', '友情提示', {
            //       dangerouslyUseHTMLString: true,
            //   confirmButtonText: '确定'
            // });
            // this.$alert('<p style="font-size:24px">因属地管理原则， <span style="color:#ff6715">鄱阳县</span> 和 <span style="color:#ff6715">婺源县</span> 的企业无法参加上饶三类人员初始考试，八大员和特种作业人员不受属地管理影响，可正常报名培训，请以上两个县的企业慎重报名，切勿报错！！</p>', '友情提示', {
            //   dangerouslyUseHTMLString: true
            // });
          }
        }
      } else {
        this.zytzDialogVisible = false;
      }
    },
    handleYqtsDialogCancel() {
      this.yqtsDialogVisible = false;
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/list.scss';
.box {
  .title {
    font-size: 30px;
    color: #333333;
    margin-bottom: 20px;
  }
  .search-row {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dedede;
    line-height: 80px;
    margin-top: 16px;
    .title {
      font-size: 30px;
      color: #333333;
      margin-bottom: 0;
    }
    .search-job {
      display: flex;
      justify-content: flex-start;
      width: 270px;
      .search-label {
        font-size: 18px;
        font-weight: bold;
        width: 130px;
      }
    }
  }
  .pics {
    display: flex;
    > div {
      margin-right: 20px;
    }
    .span_error {
      color: #ff6715;
      font-size: 14px;
    }
    .item-sc-btn {
      display: flex;
      border: 1px solid #dedede;
      color: #dedede;
      cursor: pointer;
      border-radius: 5px;
      width: 136px;
      height: 48px;
      align-items: center;

      div {
        justify-content: center;
        align-items: center;
        display: flex;
      }
      div:first-child {
        width: 32px;
        height: 48px;
        border-right: 1px solid #dedede;
        font-size: 24px;
      }
      div:nth-child(2) {
        width: 104px;
      }
      &.isActive {
        border: 1px solid #ff6715;
        color: #ff6715;
        div:first-child {
          border-right: 1px solid #ff6715;
        }
      }
    }
    .item-sc-img {
      width: 136px;
      height: 48px;
      object-fit: cover;
      border: 1px dashed #dedede;
      cursor: pointer;
      border-radius: 5px;
    }
    .btn-img {
      width: 136px;
      height: 48px;
      display: flex;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 5px;
      position: absolute;
      top: 0;
      div {
        flex: 1;
        font-size: 12px;
        justify-content: center;
        display: flex;
        cursor: pointer;
      }
    }
    .item-imgs {
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      > div {
        margin-right: 20px;
        margin: 10px 20px 10px 0;
      }
      .input_item {
        padding-top: 8px;
        width: 150px;
        .span_error {
          margin-top: -4px;
        }
      }
    }
  }
  .btn-job {
    width: 115px;
    font-size: 16px;
    text-align: center;
  }
}
.box-kpxx {
  margin-top: 40px;
  .kpxx-title {
    font-size: 30px;
    color: #333333;
    margin-bottom: 20px;
  }
  label {
    margin-bottom: 0;
  }
}
.box-dialog {
  .box-title {
    font-size: 24px;
    color: #333333;
    position: absolute;
    top: 30px;
    padding-left: 12px;
  }
  .box-row {
    display: flex;
    padding: 0 12px;
    p {
      text-indent: 32px;
      span {
        color: #ff6715;
      }
    }
  }
}

.purchase-list ul li:last-child {
  border-bottom: 3px solid #e5e5e5;
}
</style>
<style scoped>
#checkout >>> .el-table thead {
  color: #333333 !important;
  font-weight: 500;
  line-height: 40px;
}
.el-table >>> .el-table__row:hover,
.el-table >>> .el-table__row:focus {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
}

.el-button >>> .el-icon-loading {
  color: #fff;
  font-size: 20px;
}

.span-content {
  color: #ff6715;
  font-size: 16px;
  line-height: 24px;
  margin-top: 26px;
  text-align: left;
}

.span-content >>> a {
  color: #16cfd0 !important;
  font-size: 14px;
}
.search-input >>> .el-input__inner {
  border-bottom: 1px solid #dedede;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
}
#dialog-zytz >>> .el-dialog {
  margin: 0 !important;
  width: 800px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#dialog-zytz >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ff6715;
  border-color: #ff6715;
}
#dialog-zytz >>> .el-checkbox__inner {
  border: 1px solid #ff6715;
}
#dialog-zytz >>> .el-checkbox__inner:hover {
  border-color: #ff6715;
}

#dialog-yqts >>> .el-dialog {
  margin: 0 !important;
  width: 800px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/home/course_enroll.vue